import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Sin diseños listos',
    costo: 'Perdés semanas intentando diseñar stickers que no quedan bien'
  }, {
    sin: 'Sin variedad',
    costo: 'Solo podés vender de un tema y limitás tus ganancias'
  }, {
    sin: 'Sin alta resolución',
    costo: 'Tus stickers se ven pixelados y la gente no los compra'
  }, {
    sin: 'Sin licencia comercial',
    costo: 'No podés vender legalmente lo que imprimís'
  }, {
    sin: 'Sin el Mundial 2026',
    costo: 'El evento más grande del año pasa y vos no aprovechaste nada'
  }];
  return <section className="py-20 bg-zinc-900 text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-22">
          <div className="min-w-[600px]" data-id="element-23">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-24">
              <div className="font-bold text-sky-300 uppercase text-sm tracking-wider" data-id="element-25">
                Sin el Megapack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-26">
                Lo que realmente perdés
              </div>
            </div>

            <div className="space-y-2" data-id="element-27">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-black/60 rounded-xl p-4 items-center border border-sky-900/30" data-id="element-28">
                  <div className="text-zinc-100 font-medium" data-id="element-29">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-30">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-sky-400 mt-4 md:hidden" data-id="element-31">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-sky-600 to-sky-900 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-32">
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-33">
            🇦🇷⭐ "La próxima vez que alguien quiera stickers del Mundial — vas a
            ser vos quien se los vende."
          </p>
        </motion.div>
      </div>
    </section>;
}